import { mainBlue, mainGreen, mainRed } from './color'

export const generateCode = () => {
	const end = 99999999
	const start = 11111111
	return String(Math.floor(Math.random() * (end - start + 1) + start))
}

export const formatPrice = (number) => {
	const removeChar = number.toString().replace(/[^0-9.]/g, '')
	const removeDot = removeChar.replace(/\./g, '')
	const formatedNumber = removeDot.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	return formatedNumber
}

export const formatNumberToNumber = (number) => {
	return Number(number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ''))
}

export const checkValidTimer = (timer) => {
	if (timer.date === '' || timer.hours === '' || timer.minutes === '') {
		alert('Điền đầy đủ thông tin hẹn giờ!')
		return false
	} else {
		if (timer.hours < 0 || timer.hours > 23) {
			alert('Chọn giờ từ 0 đến 23')
			return false
		}
		if (timer.minutes < 0 || timer.minutes > 59) {
			alert('Chọn phút từ 0 đến 59')
			return false
		}
		const scheduleTime = new Date(
			`${timer.date.slice(3, 5)}/${timer.date.slice(0, 2)}/${timer.date.slice(6, 11)}, ${timer.hours}:${timer.minutes}`,
		).getTime()
		if (scheduleTime <= new Date().getTime()) {
			alert('Không thể hẹn giờ trong quá khứ')
			return false
		}
	}
	return true
}

export const getTextOfInternalSale = (item, unit) => {
	if (item.action === 'crossStoreSell') {
		if (item?.crossStoreOrder?.orderType === 'BUY') {
			return (
				<span>
					duyệt: <b style={{ color: mainRed }}>kho {item?.crossStoreOrder?.toStore?.name}</b> bán cho{' '}
					<b style={{ color: mainGreen }}>kho {item?.crossStoreOrder?.fromStore?.name}</b>{' '}
					<span style={{ color: mainBlue }}>-{item.quantity}</span> {unit}.
				</span>
			)
		} else {
			return (
				<span>
					duyệt: <b style={{ color: mainRed }}>kho {item?.crossStoreOrder?.fromStore?.name}</b> bán cho{' '}
					<b style={{ color: mainGreen }}>kho {item?.crossStoreOrder?.toStore?.name}</b>{' '}
					<span style={{ color: mainBlue }}>-{item.quantity}</span> {unit}.
				</span>
			)
		}
	}
	if (item.action === 'crossStoreBuy') {
		if (item?.crossStoreOrder?.orderType === 'BUY') {
			return (
				<span>
					duyệt: <b style={{ color: mainGreen }}>kho {item?.crossStoreOrder?.fromStore?.name}</b> mua từ kho{' '}
					<b style={{ color: mainRed }}>kho {item?.crossStoreOrder?.toStore?.name}</b>{' '}
					<span style={{ color: mainBlue }}>
						{item.quantity} {unit}.
					</span>
				</span>
			)
		} else {
			return (
				<span>
					duyệt: <b style={{ color: mainGreen }}>kho {item?.crossStoreOrder?.toStore?.name}</b> mua từ kho{' '}
					<b style={{ color: mainRed }}>kho {item?.crossStoreOrder?.fromStore?.name}</b>{' '}
					<span style={{ color: mainBlue }}>
						{item.quantity} {unit}.
					</span>
				</span>
			)
		}
	}
	return ''
}

export const compressImage = async (file) => {
	return new Promise((resolve) => {
		const reader = new FileReader()
		reader.onload = (event) => {
			const img = new Image()
			img.onload = () => {
				const MAX_WIDTH = 1920
				let width = img.width
				let height = img.height

				// Calculate new dimensions if width exceeds MAX_WIDTH
				if (width > MAX_WIDTH) {
					height = Math.round((height * MAX_WIDTH) / width)
					width = MAX_WIDTH
				}

				const canvas = document.createElement('canvas')
				canvas.width = width
				canvas.height = height

				const ctx = canvas.getContext('2d')
				ctx.drawImage(img, 0, 0, width, height)

				canvas.toBlob(
					(blob) => {
						const compressedFile = new File([blob], file.name, {
							type: 'image/jpeg',
							lastModified: Date.now(),
						})
						resolve(compressedFile)
					},
					'image/jpeg',
					0.8,
				)
			}
			img.src = event.target.result
		}
		reader.readAsDataURL(file)
	})
}
